import { stock } from './role'

export const queries = {
  stock,
}
export default queries
